import { createElementObject, createPathComponent, extendContext } from './core';
import L from '@anlan/gs-map';
import type { LeafletContextInterface, PathProps } from './core';
import type { LayerGroupProps } from './LayerGroup';
const LeafletFeatureGroup = L.FeatureGroup;

export interface FeatureGroupProps extends LayerGroupProps, PathProps {}

export const FeatureGroup = createPathComponent(function createFeatureGroup({ children, ...options }: FeatureGroupProps, ctx: LeafletContextInterface) {
    void children;
    const group = new LeafletFeatureGroup([], options);
    return createElementObject(group, extendContext(ctx, {
        layerContainer: group,
        overlayContainer: group
    }));
});
